module.exports = __webpack_public_path__ + "static/assets/img/educatuions_form.ff33ebe0.svg";